(function () {
    'use strict';

    class Event {
        constructor(name) {
            this._listeners = [];
            this._dataQueue = [];
            this._name = name;
        }
        getName() {
            return this._name;
        }
        registerListener(callback, singleRun = false) {
            const listener = {
                singleRun,
                callback
            };
            const duplicateListeners = this._listeners.filter((item) => {
                return listener.singleRun !== item.singleRun && listener.callback !== item.callback;
            });
            if (duplicateListeners.length === 0) {
                this._listeners.push(listener);
            }
            return listener;
        }
        queueData(dataList) {
            this._dataQueue.push(dataList);
        }
        clearData() {
            this._dataQueue = [];
        }
        removeListener(callback) {
            let deleted = false;
            this._listeners.forEach((listener, index, array) => {
                if (listener.callback === callback) {
                    array.splice(index, 1);
                    deleted = true;
                }
            });
            return deleted;
        }
        emitListener(listener, dataList = []) {
            setTimeout(() => {
                try {
                    listener.callback.call(listener.callback, ...dataList);
                }
                catch (error) {
                    console.error(`[EventQBus] listener for event '${this.getName()}' failed with `, error);
                }
            }, 0);
            if (listener.singleRun) {
                const listenerIndex = this._listeners.indexOf(listener);
                if (listenerIndex > -1) {
                    this._listeners.splice(listenerIndex, 1);
                }
            }
        }
        emitAllListener(dataList) {
            this._listeners.forEach((listener) => {
                this.emitListener(listener, dataList);
            });
        }
        emitListenerWithQueuedData(listener) {
            if (this._dataQueue.length) {
                if (listener.singleRun) {
                    this.emitListener(listener, this._dataQueue[0]);
                }
                else {
                    this._dataQueue.forEach((dataList) => {
                        this.emitListener(listener, dataList);
                    });
                }
            }
        }
    }

    class Handler {
        constructor() {
            this._eventMap = {};
            this._allScriptsExecuted = false;
            this._onAllScriptsExecuted = () => {
                this._allScriptsExecuted = true;
                Object.keys(this._eventMap).forEach((topic) => {
                    this._eventMap[topic].clearData();
                });
            };
            const o_global = window.o_global;
            if (o_global && o_global.eventLoader && typeof o_global.eventLoader.onAllScriptsExecuted === "function") {
                o_global.eventLoader.onAllScriptsExecuted(Handler._SCRIPTS_EXECUTED_PRIORITY, this._onAllScriptsExecuted);
            }
        }
        _getOrCreateEventForTopic(topic) {
            return this._eventMap[topic] || (() => {
                const event = new Event(topic);
                this._eventMap[topic] = event;
                return event;
            })();
        }
        _validateTopic(topic) {
            const validationRegex = /^[a-zA-Z0-9\-]{2,}\.[a-zA-Z0-9\-]{3,}\.[a-zA-Z0-9\-]{3,}$/;
            if (!(typeof topic === "string" && validationRegex.test(topic))) {
                throw new Error(`[EventQBus] topic name '${topic}' is invalid, please match regex syntax '${validationRegex.toString()}' (e.g. "assets.rum.fired")`);
            }
        }
        _isValidCallback(callback) {
            return typeof callback === "function";
        }
        _handleConsumer(topic, callback, singleRun) {
            this._validateTopic(topic);
            if (this._isValidCallback(callback)) {
                const event = this._getOrCreateEventForTopic(topic);
                const listener = event.registerListener(callback, singleRun);
                if (listener) {
                    if (!this._allScriptsExecuted) {
                        event.emitListenerWithQueuedData(listener);
                    }
                    return listener.callback;
                }
            }
            return null;
        }
        _handleProducer(topic, data) {
            this._validateTopic(topic);
            const event = this._getOrCreateEventForTopic(topic);
            if (!this._allScriptsExecuted) {
                event.queueData(data);
            }
            event.emitAllListener(data);
        }
        on(topic, callback) {
            return this._handleConsumer(topic, callback, false);
        }
        once(topic, callback) {
            return this._handleConsumer(topic, callback, true);
        }
        off(topic, callback) {
            const event = this._eventMap[topic];
            return event ? event.removeListener(callback) : false;
        }
        emit(topic, ...data) {
            this._handleProducer(topic, data);
        }
    }
    Handler._SCRIPTS_EXECUTED_PRIORITY = 1000;

    window.o_global = window.o_global || {};
    window.o_global.eventQBus = window.o_global.eventQBus || new Handler();

}());
